import { ILogMessages } from "../domain/ILogMessages";

export const logger: ILogMessages = {
  log(...values: any[]) {
    console.log(...values);
  },
};
